/* eslint-disable react/no-array-index-key */
/* eslint-disable sort-keys */
import React from 'react'

import { AccordionItemComponent } from '../../components'
import { SectionContainer } from '../../layouts'
import {
  ALLOWED_WORDS,
  ContentParser,
  hasNulls,
  replaceWordInString,
} from '../../utils/helpers'
import {
  activeTitleStyling,
  headingContainerStyling,
  questionsContainer,
  sectionContent,
  titleStyling,
} from './FaqSection.module.css'

const FaqSection = ({ lang, slice }) => {
  const { containerwidth, faqsectionheading, faqsectionkicker } = slice
  const questions = ContentParser(slice, 'faqitem').filter(
    (res) => !hasNulls(Object.values(res)),
  )
  if (questions.length === 0) return null

  return (
    <SectionContainer
      containerwidth={containerwidth}
      extraHeadingContainerClassName={headingContainerStyling}
      heading={replaceWordInString(
        faqsectionheading,
        'botox',
        ALLOWED_WORDS[lang],
      )}
      kicker={replaceWordInString(
        faqsectionkicker,
        'botox',
        ALLOWED_WORDS[lang],
      )}
      withHeader
    >
      <ul className={questionsContainer}>
        {questions.length > 0 &&
          questions.map((question, index) => {
            return (
              <AccordionItemComponent
                key={index}
                active
                contentClassname={sectionContent}
                extraActiveTitleClassName={activeTitleStyling}
                extraTitleClassname={titleStyling}
                faqSection
                item={{
                  title: replaceWordInString(
                    question.questiontitle,
                    'botox',
                    ALLOWED_WORDS[lang],
                  ),
                  content: replaceWordInString(
                    question.questioncontent,
                    'botox',
                    ALLOWED_WORDS[lang],
                  ),
                }}
              />
            )
          })}
      </ul>
    </SectionContainer>
  )
}

export default FaqSection
